<template>
  <div
      class="default flex flex-col min-w:[370px] min-h-screen">
    <div class="grow">
      <router-view />
    </div>
  </div>
</template>

<script setup>
</script>
